import { create } from "zustand";

export interface ProductIdentity {
  id: number;
  ProductId: number;
  ProdProperties: {
    Attribute: Attribute;
    Property: Property;
  }[];
  Warehouses: Warehouse[];
}

interface Warehouse {
  warehouse_price: number;
  warehouse_discount: number;
  warehouse_available: boolean;
  warehouse_count: number;
  ProductId: number;
  ProductIdentityId: number;
}

interface Property {
  id: number;
  property_name: string;
  property_main: boolean;
  property_price: boolean;
}

interface Attribute {
  id: number;
  attribute_name: string;
}

interface ProductState {
  checkSellButton: {
    ProductId: number;
    available: boolean;
    property: { attr: string; property: string }[];
    ProductIdentityId: number;
    warehouse_price: number;
    warehouse_discount: number;
  } | null;
  setCheckSellButton: (data: ProductIdentity[], urlPi: number) => void;
}
const useProductStore = create<ProductState>((set) => ({
  checkSellButton: null,
  setCheckSellButton: (data, urlPi) => {
    const check = data?.filter((i) => i.id === urlPi);
    const result = check.map((i) => {
      const ProductId = i.ProductId;

      // Collect all properties
      const property = i.ProdProperties.map((pp) => ({
        attr: pp.Attribute.attribute_name,
        property: pp.Property.property_name,
      }));

      // Check if any warehouse is available with a count greater than 0
      const available = i.Warehouses.some(
        (wh) => wh.warehouse_available && wh.warehouse_count > 0
      );

      const ProductIdentityId = i.id;
      const warehouse_price = i.Warehouses[0]?.warehouse_price ?? 0;
      const warehouse_discount = i.Warehouses[0]?.warehouse_discount ?? 0;

      return {
        ProductId,
        available,
        property,
        ProductIdentityId,
        warehouse_price,
        warehouse_discount,
      };
    });
    set({ checkSellButton: result[0] });
  },
}));

export default useProductStore;
